import type { ViewConfigKpiPreset } from '@salescore/core'
import type { ModalFuncProps } from 'antd'
import { t } from 'i18next'

import type { PresetParameterKeys } from './KpiPresetForm'
import { ViewConfigKpiPresetForm } from './KpiPresetForm'

export const buildKpiPresetFormModalProperties = ({
  preset,
  presets,
  initialSelectedKeys,
  onFinish,
}: {
  preset?: ViewConfigKpiPreset
  presets: ViewConfigKpiPreset[] | undefined
  initialSelectedKeys: PresetParameterKeys[]
  onFinish: (newPreset: ViewConfigKpiPreset) => void
}): ModalFuncProps => ({
  icon: null,
  width: '90%',
  cancelText: t(`閉じる`),
  okButtonProps: { style: { display: 'none' } },
  title: (
    <div>
      {t(`集計プリセットの{{title}}`, {
        title: preset === undefined ? t(`新規作成`) : t(`編集`),
      } satisfies { title: string })}
    </div>
  ),
  style: { top: '3%' },
  closable: true,
  maskClosable: true,
  destroyOnClose: true,
  footer: null,
  content: (
    <div className="w-full overflow-x-scroll">
      {/* eslint-disable-next-line sonarjs/fixme-tag */}
      {/* FIXME: overflow-x-scroll は Windows で常時スクロールバーが表示され下部にグレー帯が出る (#8572)。overflow-x-auto への変更を検討 */}
      <ViewConfigKpiPresetForm
        preset={preset}
        presets={presets}
        initialSelectedKeys={initialSelectedKeys}
        onFinish={onFinish}
      />
    </div>
  ),
})
